/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * OrderDeliveryDateMetadataDtoBase
 * auto generated base class for the model OrderDeliveryDateMetadataDtoModel.
 */
export const OrderDeliveryDateMetadataDtoModelBase = ModelBase
  .named('OrderDeliveryDateMetadataDto')
  .props({
    __typename: types.optional(types.literal("OrderDeliveryDateMetadataDto"), "OrderDeliveryDateMetadataDto"),
    earliestDate: types.union(types.undefined, types.null, types.string),
    unscheduledOrdersCount: types.union(types.undefined, types.null, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrderDeliveryDateMetadataDtoModelSelector extends QueryBuilder {
  get earliestDate() { return this.__attr(`earliestDate`) }
  get unscheduledOrdersCount() { return this.__attr(`unscheduledOrdersCount`) }
}
export function selectFromOrderDeliveryDateMetadataDto() {
  return new OrderDeliveryDateMetadataDtoModelSelector()
}

export const orderDeliveryDateMetadataDtoModelPrimitives = selectFromOrderDeliveryDateMetadataDto().earliestDate.unscheduledOrdersCount
